export const copyTextToClipboard = async (text: string): Promise<void> => {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
};

export const openTelegramShare = (link: string) => {
    window.open(`https://t.me/share/url?url=${encodeURIComponent(link)}`, '_blank');
};

export const openWhatsAppShare = (link: string) => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(link)}`, '_blank');
};

export const openFacebookShare = (link: string) => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`, '_blank');
};
